import { Form, Input } from "antd";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { withFloatingLabel } from "src/HOC/WithFloatingLabel";
import Carrier from "@Components/Carrier/Carrier";
import { PassengerIcon } from "src/assets/Icons";
import GuestsSelectionContent from "../../GuestsSelectionContent/GuestsSelectionContent";

const FloatingInput = withFloatingLabel(Input);

type RoomType = { adults: number; children: number; childrenAges: number[] };

const GuestsSelectionMob: FC<{ label?: ReactNode }> = ({ label }) => {
  const { t } = useTranslation();
  const rooms: RoomType[] = Form.useWatch("rooms") ?? [];
  const adultsCount = rooms.reduce((acc, r) => acc + (r.adults || 0), 0);
  const childrenCount = rooms.reduce((acc, r) => acc + (r.children || 0), 0);
  const displayValue = t("Hotels.search.roomsAndGuests", { rooms: rooms.length || 1, guests: adultsCount + childrenCount });

  return Carrier({
    label,
    renderTrigger: ({ open }) => (
      <div className="border-b border-border-default flex w-full flex-1 items-center gap-1 px-1 text-font-minimal">
        <PassengerIcon className="h-4! w-4! shrink-0" />
        <FloatingInput
          label={label}
          readOnly
          value={displayValue}
          className="outline-none! border-none! pt-5! pb-1! px-3! gap-4! font-semibold!"
          onClick={open}
        />
      </div>
    ),
    renderSheet: () => <GuestsSelectionContent className="max-h-[70%] overflow-y-auto p-4" />,
  });
};

export default GuestsSelectionMob;
